import React, { Fragment, useEffect, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';

const TabsTemplate = (props) => {
    const { style } = props;
    const [selectedTab, setSelectedTab] = useState(props.defaultActiveKey || "nav-0")
    useEffect(() => {
        if (props.activeKey) {
            setSelectedTab(props.activeKey)
        }
    }, [props.activeKey])
    const isMobile = useMediaQuery({ query: `(max-width: 576px)` });
    //children to an array
    const childrenArray = Array.isArray(props.children) ? props.children : [props.children];
    // Filter out children with hide prop set to true
    const filteredChildren = childrenArray.filter(child => !child.props.hide);
    return (
        <nav>
            {!isMobile || props.noMobileOpt ? <>
                    {Array.isArray(filteredChildren) && (
                        <Tabs 
                            className="tabs" 
                            variant={props.style && props.style} 
                            id={props.id} 
                            defaultActiveKey={props.defaultActiveKey || 'nav-0'} 
                            activeKey={props.activeKey || selectedTab} 
                            onSelect={k => { 
                                if (props.onSelect) { 
                                    props.onSelect(k); 
                                } 
                                setSelectedTab(k); 
                            }} 
                            mountOnEnter 
                            unmountOnExit
                        >
                            {filteredChildren.map((body, i) => {
                                let active = false;
                                if ('nav-' + i === selectedTab || props.activeKey === selectedTab) { 
                                    active = true; 
                                }
                                return (
                                    <Tab 
                                        className="tab-content" 
                                        onTabChange={e => { 
                                            e.preventDefault(); 
                                            props.onTabChange(); 
                                        }} 
                                        eventKey={body.props.eventKey || `nav-${i}`} 
                                        title={body.props.title} 
                                        disabled={body.props.disabled || false} 
                                        key={i}
                                    >
                                        <div 
                                            className={active ? 'tab-pane fade show active py-3' : 'tab-pane fade py-3'} 
                                            role="tabpanel" 
                                            aria-labelledby={body.props.eventKey + "-tab" || `nav-${i}-tab`}
                                        >
                                            {body.props.children}
                                        </div>
                                    </Tab>
                                );
                            })}
                        </Tabs>
                    )}
                    {/* {Array.isArray(props.children) === false && 
                // <Tabs className="tabs" varient={props.style && props.style} id={props.id} activeKey={selectedTab || null} onSelect={k => setSelectedTab(k)}>
                //     <Tab className="tab-content" eventKey={`nav-0`} title={props.children.props.title}>
                //         <div className='tab-pane fade show active p-3' eventKey={`nav-0`} role="tabpanel" aria-labelledby={`nav-0-tab`}>
                           props.children.props.children
                //         </div>
                //     </Tab>
                // </Tabs>
                } */}
                </>
                :
                <div>
                    {Array.isArray(filteredChildren) && (
                        <div className='field mb-3'>
                            <label>{props?.menuTitle ? props.menuTitle : ''}</label>
                            <select 
                                className='form-select' 
                                value={props.activeKey || selectedTab} 
                                onChange={e => { 
                                    e.preventDefault(); 
                                    setSelectedTab(e.target.value); 
                                }}
                            >
                                {filteredChildren.map((child, i) => (
                                    <option 
                                        value={child.props.eventKey || `nav-${i}`}
                                    >
                                        {child.props.title}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    {Array.isArray(filteredChildren) ? (
                        filteredChildren.map((child, i) => {
                            let active = false;
                            if ('nav-' + i === selectedTab || child.props.eventKey === selectedTab) { 
                                active = true; 
                            }
                            return (
                                active && (
                                    <div className='col-12'>
                                        {child.props.children}
                                    </div>
                                )
                            );
                        })
                    ) : (
                        <div className='col-12'>
                            {filteredChildren.props.children}
                        </div>
                    )}
                </div>}
        </nav>
    )
}

export default TabsTemplate